<template>
	<div class="pc-agree-box">
		<div>
			<span @click="handleClick" class="agree" :class="{ 'no-agree': !isAgree }"></span>
			{{ t("user.pc.wallet.agreementPrefix") }}
			<a :href="agreementUrl" target="_blank">{{ t("user.pc.wallet.agreementLink") }}</a>
		</div>
	</div>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "~/composables/useI18n";

const { t, locale } = useI18n();
const isAgree = defineModel({ type: Boolean, default: true });

const agreementUrl = computed(() => {
	const lang = locale.value === "en" ? "en_us" : "zh_tw";
	return `/dist/protocol/website/service-agreement?lang=${lang}`;
});

const handleClick = () => {
	isAgree.value = !isAgree.value;
};
</script>

<style lang="scss" scoped>
.pc-agree-box {
	display: flex;
	font-family: Source Han Sans CN;
	font-size: 14px;
	color: #666666;
	line-height: 24px;
	align-items: center;

	.agree {
		position: relative;
		margin-bottom: -3px;
		display: inline-block;
		width: 16px;
		height: 16px;
		border-radius: 50%;
		background: #111111;
		cursor: pointer;
		margin-right: 4px;
		box-sizing: border-box;

		&::after {
			content: "";
			position: absolute;
			left: 5px;
			top: 2px;
			width: 4px;
			height: 7px;
			border: solid #ffffff;
			border-width: 0 1.5px 1.5px 0;
			transform: rotate(45deg);
		}
	}

	.no-agree {
		background: url("@/assets/images/icon_no_agree.png") no-repeat center center/ 100% 100%;

		&::after {
			display: none;
		}
	}

	a {
		color: #333333;
	}
}
</style>
